import * as Icon from './Icons';

const events = {
    offlineReady: 'offlineReady',
    updateAvailable: 'updateAvailable'
};

const messageTimeout = 5000;

const navLinks = [
    {
        route: '/cards',
        icon: Icon.Cards,
        text: 'nav_cards'
    },
    {
        route: '/howto',
        icon: Icon.Howto,
        text: 'nav_howto'
    },
    {
        route: '/more',
        icon: Icon.More,
        text: 'nav_more'
    }
];

export { events, navLinks, messageTimeout };



// WEBPACK FOOTER //
// ./src/config.js